import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteAGoldScheme,
  getAllGoldSchemes,
} from "../features/goldScheme/goldSchemeSlice";
import CustomModal from "../components/CustomModal";

const formatRupees = (amount) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(amount || 0);

const columns = [
  { title: "SNo", dataIndex: "key" },
  { title: "Customer Name", dataIndex: "full_name" },
  { title: "Email", dataIndex: "email" },
  { title: "Mobile", dataIndex: "mobile" },
  { title: "Scheme Name", dataIndex: "scheme_name" },
  { title: "Installment Paid", dataIndex: "hapta_paid" },
  { title: "Action", dataIndex: "action" },
];

const GoldSchemeList = () => {
  const [open, setOpen] = useState(false);
  const [schemeId, setSchemeId] = useState("");
  const dispatch = useDispatch();
  const schemeState = useSelector((state) => state.goldScheme.schemes);
  const isLoading = useSelector((state) => state.goldScheme.isLoading);

  useEffect(() => {
    dispatch(getAllGoldSchemes());
  }, [dispatch]);

  const showModal = (id) => {
    setOpen(true);
    setSchemeId(id);
  };

  const hideModal = () => setOpen(false);

  const deleteScheme = (id) => {
    dispatch(deleteAGoldScheme(id));
    setOpen(false);
    setTimeout(() => {
      dispatch(getAllGoldSchemes());
    }, 100);
  };

  const dataSource = schemeState?.length
    ? schemeState.map((scheme, index) => ({
        key: index + 1,
        full_name: scheme.full_name,
        email: scheme.email,
        mobile: scheme.mobile,
        scheme_name: scheme.scheme_name,
        hapta_paid: formatRupees(scheme.hapta_paid),
        action: (
          <>
            <Link
              to={`/admin/gold-scheme/${scheme._id}`}
              className="fs-3 text-danger"
            >
              <BiEdit />
            </Link>
            <button
              className="ms-3 fs-3 text-danger bg-transparent border-0"
              onClick={() => showModal(scheme._id)}
            >
              <AiFillDelete />
            </button>
          </>
        ),
      }))
    : [];

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3 className="mb-0 title">11+1 / Gold Scheme</h3>
        <Link to="/admin/gold-scheme" className="btn btn-success border-0 rounded-3">
          Add Scheme Customer
        </Link>
      </div>
      <Table
        columns={columns}
        dataSource={dataSource}
        loading={isLoading}
        pagination={{ pageSize: 10 }}
      />
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => deleteScheme(schemeId)}
        title="Are you sure you want to delete this scheme customer?"
      />
    </div>
  );
};

export default GoldSchemeList;
